module.exports = __webpack_public_path__ + "static/media/new_do_card.1eb0897a.svg";